import styles from './cookie-drawer.module.css';

import { Box, Button, Card, Flex, Text } from '@radix-ui/themes';
import { createPortal } from 'react-dom';
import { COOKIES_TITLE } from '@/app/lib/constants/messages';
import { BUTTON_NAMES } from '@/app/lib/constants/button-names';
import SolidButton from './shared/solid-button';
import MarkdownBlock from '../markdown/markdown-block';
import { ANALYTICS_CONSENT } from '@/app/lib/constants/cookie-values';

interface Props {
  render: boolean;
  drawerPortal: HTMLElement | null;
  isOpen: boolean;
  setConsent: (value: ANALYTICS_CONSENT) => void;
  markdown: string;
}

export default function CookieDrawer({
  render,
  drawerPortal,
  isOpen,
  setConsent,
  markdown
}: Props) {
  return (
    <>
      {render &&
        drawerPortal &&
        createPortal(
          <div className={styles.Drawer}>
            <div
              className={`${styles.DrawerInner} ${isOpen ? styles.open : ''}`}
            >
              <Card className={styles.CookieDrawerContent}>
                <Box p='4'>
                  <Flex
                    direction='column'
                    width='100%'
                    gap='4'
                  >
                    <Text
                      as='div'
                      size='5'
                    >
                      {COOKIES_TITLE}
                    </Text>
                    <MarkdownBlock markdown={markdown} />
                    <Flex
                      direction={{ initial: 'column', sm: 'row' }}
                      justify={{ initial: 'center', sm: 'start' }}
                      px={{ initial: '4', sm: 'auto' }}
                      pb='4'
                      gap='4'
                    >
                      <SolidButton
                        onClick={() => setConsent(ANALYTICS_CONSENT.ACCEPTED)}
                      >
                        {BUTTON_NAMES.acceptAnalyticsCookies}
                      </SolidButton>
                      <Button
                        onClick={() => setConsent(ANALYTICS_CONSENT.REJECTED)}
                        variant='surface'
                      >
                        {BUTTON_NAMES.rejectAnalyticsCookies}
                      </Button>
                    </Flex>
                  </Flex>
                </Box>
              </Card>
            </div>
          </div>,
          drawerPortal
        )}
    </>
  );
}
